/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import Config from "data/config";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const enableImageDebug = Config.Debug.enableDiagnostics;

const ScaledFullWidthImage = (props) => {
    
    const { image, settings } = props || {};
    const message = "No image to display";
    const component = { type: "component.image" };
    
    const { dimension = "100%", forceSixteenNine = false } = settings || {};
    const { width, height } = image || {};
    const hasWidth = !!width;
    const hasHeight = !!height;
    let aspect_ratio;
    if (forceSixteenNine) {
        // use 16/9 default
        aspect_ratio = "16/9";
    } else if (hasWidth && hasHeight) {
        const longerSide = height >= width ? "height" : "width";
        aspect_ratio = (longerSide === "height") ? `${height}/${width}` : `${width}/${height}`;
    } else {
        // leave aspect_ratio undefined
    }
    
    return (
        <>
            {image &&
                <>
                    {enableImageDebug &&
                        <h6>FullWidth Image (width: {dimension})</h6>
                    }
                    <img
                        src={image.url}
                        alt={image.alt}
                        width={dimension}
                        style={{
                            aspectRatio: aspect_ratio
                        }}
                    />

                </>
            }
            {!image &&
                <>
                    <EmptyContentMessage
                        hasContent={!image}
                        message={message}
                        component={component}
                    />
                </>
            }
        </>
    );
};

export default ScaledFullWidthImage;
